import { render, staticRenderFns } from "./syllabuses.vue?vue&type=template&id=37108eac&scoped=true"
import script from "./syllabuses.vue?vue&type=script&lang=js"
export * from "./syllabuses.vue?vue&type=script&lang=js"
import style0 from "./syllabuses.vue?vue&type=style&index=0&id=37108eac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37108eac",
  null
  
)

export default component.exports